export default "__VITE_ASSET__2459c824__"